import Component from "@bythepixel/component-loader";

export default class StickySubnavigation extends Component {
  static loaderPriority = "in-view";
  static selector = "[data-comp-sticky-subnavigation]";

  constructor(containerEl) {
    super(containerEl);
    this.parentContainer = this.$container.parentElement;
    this.activeClass = "active";
    this.stickToTop = this.$container.hasAttribute("data-stick-to-top");
    this.generateParentContainerPosition();
    this.determineSubnavVisibility();
    this.addListeners();
  }

  addListeners() {
    this.addScrollListener();
    this.addWindowResizeListener();
    this.addOnUnloadListener();
  }

  addScrollListener() {
    this.determineSubnavVisibility = this.determineSubnavVisibility.bind(this);
    window.addEventListener("scroll", this.determineSubnavVisibility);
  }

  removeScrollListener() {
    window.removeEventListener("scroll", this.determineSubnavVisibility);
  }

  determineSubnavVisibility() {
    requestAnimationFrame(() => {
      const scrollBottom = window.innerHeight + window.scrollY;

      if (
        this.stickToTop &&
        !window.matchMedia("(min-width: 768px)").matches &&
        window.scrollY > this.parentTop &&
        scrollBottom < this.parentBottom
      ) {
        this.$container.classList.add(this.activeClass);
      } else if (this.stickToTop) {
        this.$container.classList.remove(this.activeClass);
      } else if (
        !window.matchMedia("(min-width: 992px)").matches &&
        scrollBottom > this.parentTop &&
        scrollBottom < this.parentBottom
      ) {
        this.$container.classList.add(this.activeClass);
      } else if (
        window.matchMedia("(min-width: 992px)").matches &&
        window.scrollY > this.parentTop &&
        window.scrollY < this.parentBottom
      ) {
        this.$container.classList.add(this.activeClass);
      } else {
        this.$container.classList.remove(this.activeClass);
      }
    });
  }

  generateParentContainerPosition() {
    this.parentTop = this.parentContainer.offsetTop;
    this.parentHeight = this.parentContainer.offsetHeight;
    this.parentBottom = this.parentTop + this.parentHeight;
  }

  addWindowResizeListener() {
    this.windowResize = this.windowResize.bind(this);
    window.addEventListener("resize", this.windowResize);
  }

  removeWindowResizeListener() {
    window.removeEventListener("resize", this.windowResize);
  }

  windowResize() {
    requestAnimationFrame(() => {
      this.generateParentContainerPosition();
      this.determineSubnavVisibility();
    });
  }

  addOnUnloadListener() {
    window.onunload = () => {
      this.removeScrollListener();
      this.removeWindowResizeListener();
    };
  }
}
